import React, { useState, useEffect } from 'react';
import { useCSS } from '../../lib/hooks.js';
import { useCanvasMachine } from '../../ts/games/canvasStateMachine.ts';
import Spinner from '../builder/Spinner.js';
import PeelMeCanvas from './PeelMeCanvas';

const PeelMeContainer = (props) => {
	useCSS('comp/peel_me_effect.css');

	const is_builder = props?.is_builder ?? false;

	const scroll_prevent_dom = (!is_builder) ? 'body' : '.gui_preview_full_container';

	const [ is_loaded, setIsLoaded ] = useState(false);
	const [ is_finished, setIsFinished ] = useState(false);
	const [ canvas_size, setCanvasSize ] = useState({ w:100, h:100 });

	const promotion = props?.promotion?.Promotion ?? (props?.promotion ?? false);

	const fitStageIntoParentContainerDelayed = () => {
		setTimeout(() => {
			fitStageIntoParentContainer();
		}, 100);
	};

	const fitStageIntoParentContainer = () => {
		const container = document.querySelector('.peel_me_container');
		setCanvasSize({ w:container.clientWidth, h:container.clientHeight });
	};

	const preventScrollEvents = () => {
		window.scrollTo(0, 0);	// <---- this was the b**ch that broke the code when scrolling down (on mobile) when in register form. Remember this!
		document.querySelector(scroll_prevent_dom).style.overflow = 'hidden';
	};

	const restoreScrollEvents = () => {
		document.querySelector(scroll_prevent_dom).style.overflow = 'visible';
	};

	useEffect(() => {
		window.scrollTo(0, 0);

		preventScrollEvents();
		fitStageIntoParentContainer();

		setIsLoaded(true);

		window.addEventListener('resize', fitStageIntoParentContainerDelayed);

		return () => {
			window.removeEventListener('resize', fitStageIntoParentContainerDelayed);
		};
	}, []);

	const canvas_images = () => {
		const images = [];
		if(promotion.peel_cover_image) {
			const cover_image_fullscreen = promotion?.peel_cover_image_fullscreen ?? false;

			images.push({
				id:`peel_cover_image`,
				name:promotion.peel_cover_image,
				url:promotion.full_peel_cover_image,
				image:promotion.full_peel_cover_image,
				use_full_size:cover_image_fullscreen,
				fit:(cover_image_fullscreen) ? 'cover' : 'contain',
			});
		}

		if(promotion.peel_back_image) {
			images.push({
				id:`peel_back_image`,
				name:promotion.peel_back_image,
				url:promotion.full_peel_back_image,
				image:promotion.full_peel_back_image,
				use_full_size:true,
				fit:'cover',
			});
		}

		return images;
	}

	const [ state, dispatch ] = useCanvasMachine({
		images:canvas_images,
		images_dependencies:[
			promotion?.peel_cover_image,
			promotion?.peel_back_image,
		],
	});

	const onFinish = () => {
		setIsFinished(true);
		restoreScrollEvents();
	};

	if(is_finished) return null;

	const cover_color = promotion?.peel_cover_color ?? 'rgba(180, 0, 0, 1)';

	return (
		<div class={`peel_me_container${(is_builder) ? ' is_builder' : ''}`}>
			{(is_loaded && state.state == 'LOADED') ? (
				<PeelMeCanvas
					promotion={promotion}
					indexed_images={state.images}
					canvas_size={canvas_size}
					onFinish={onFinish}
					is_builder={is_builder}
				/>
			) : (
				<div class='is_fullscreen relative_to_container' style={{ backgroundColor:cover_color }}>
					<Spinner />
				</div>
			)}
		</div>
	)
};

export default PeelMeContainer;